import type { ExpandedPet, PetTypes } from '~/common/types/search';

export const mapPetArrayToPetTypes = (input?: ExpandedPet[]): PetTypes => {
  const result: Partial<PetTypes> = {};

  if (!input) {
    return result as PetTypes;
  }

  for (const { type, otherType, dogType } of input) {
    const key = otherType || dogType || type;
    if (!key) {
      continue;
    }

    result[key] = `${Number(result[key] || 0) + 1}`;
  }

  return result as PetTypes;
};
